import styled from 'styled-components';

export const StatusContainer = styled.div`
    width: 100%;
    height: 100%;
    background-color: #f9fafb;
    border: 1px solid #eaecf0;
    text-align: center;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
`;
